import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './NavigationMenu.css';

const NavigationMenu = (props) => {
  const {
    to, title, activeKey, location, toggleSearch,
  } = props;
  const handleClick = () => {
    toggleSearch({
      closeOnly: true,
    });
  };
  return (
    <Link
      className={
        location.pathname.indexOf(activeKey) !== -1 ? 'navbar-item is-active' : 'navbar-item'
      }
      to={to}
      onClick={handleClick}
    >
      {title}
    </Link>
  );
};

NavigationMenu.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  activeKey: PropTypes.string.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  toggleSearch: PropTypes.func.isRequired,
};

NavigationMenu.defaultProps = {
  location: {
    pathname: '/',
  },
};

export default NavigationMenu;



// WEBPACK FOOTER //
// ./src/components/NavigationMenu.js